module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-mindfulness-skills.e60c11c8.png";